import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

export const updateValidador = async (isDisponible) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/update/validador/disponible",
    {
      ...config,
      params: { isDisponible },
    }
  );

  return serverResponse.data;
};

export const getValidadoresList = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/agente/validadores/disponibles",
    config
  );

  return serverResponse.data;
};
